/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FavoriteHotelMembershipResponse
 */
export interface FavoriteHotelMembershipResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof FavoriteHotelMembershipResponse
     */
    propertyIds: Array<number>;
}

/**
 * Check if a given object implements the FavoriteHotelMembershipResponse interface.
 */
export function instanceOfFavoriteHotelMembershipResponse(value: object): value is FavoriteHotelMembershipResponse {
    if (!('propertyIds' in value) || value['propertyIds'] === undefined) return false;
    return true;
}

export function FavoriteHotelMembershipResponseFromJSON(json: any): FavoriteHotelMembershipResponse {
    return FavoriteHotelMembershipResponseFromJSONTyped(json, false);
}

export function FavoriteHotelMembershipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteHotelMembershipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyIds': json['property_ids'],
    };
}

export function FavoriteHotelMembershipResponseToJSON(json: any): FavoriteHotelMembershipResponse {
    return FavoriteHotelMembershipResponseToJSONTyped(json, false);
}

export function FavoriteHotelMembershipResponseToJSONTyped(value?: FavoriteHotelMembershipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'property_ids': value['propertyIds'],
    };
}

